import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Redefinepatientservices() {
  return (
    <section
      className="redefinepatient_services p-100 tekgrip_section"
      style={{ backgroundColor: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <h2>
              Redefine Patient Experience With a Top-Rated Healthcare Mobile App
              Development Company
            </h2>
            <p>
              With our specialized healthcare application development, you can
              revolutionize patient care. Our experienced medical app developers
              incorporate state-of-the-art eHealth tools for smooth, effective
              care, from scheduling to treatment and modern patient
              examinations.
            </p>
          </Col>
        </Row>
        <Row className="mt-lg-5 mt-md-3 md-sm-2">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <Tab.Container id="" defaultActiveKey="0">
                <Row>
                  <Col xs={12} md={6} lg={6} xl={6} className="redefine_tabs">
                    <Nav variant="pills" className="flex-column">
                      <div className="red_item">
                        <Nav.Item>
                          <Nav.Link eventKey="0">
                            01. Custom Healthcare Software Development
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="1">
                            02. Laboratory Information Management System (LIMS)
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="2">
                            03. Custom mHealth App Development
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="3">
                            04. Electronic Health Record Software
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="4">
                            05. Telemedicine App Development
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="5">
                            06. Pharmacy Management App Development
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="6">
                            07. HIPAA-Compliant Software
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="7">
                            08. Wearable Technology Integration
                          </Nav.Link>
                        </Nav.Item>
                      </div>
                    </Nav>
                  </Col>
                  <Col xs={12} md={6} lg={6} xl={6} className="p-0">
                    <Tab.Content>
                      <Tab.Pane eventKey="0">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/redefine-img/custom_health.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Custom Healthcare Software Development</h3>
                        <p>
                          As a top healthcare app development service provider,
                          we design and construct captivating applications that
                          improve patient experiences and expedite medical
                          procedures such as data management, secure messaging,
                          remote monitoring, and appointment booking. Our
                          medical health app developers team has practical
                          experience developing intricate software solutions. We
                          provide smart healthcare solutions to enrich patient
                          care and lead to better health outcomes.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="1">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/redefine-img/labortory.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Laboratory Information Management System (LIMS)</h3>
                        <p>
                          Our healthcare app development services also include
                          the creation of advanced customized healthcare
                          software solutions for information management
                          depending on the lab size and their specialties. As
                          one of the best healthcare mobile app development
                          companies, we create flexible and scalable LIMS
                          solutions to guarantee extensive laboratory
                          administration, including storage, inventory, data
                          integrity, security, and protocol executions.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/redefine-img/custom_mhealth.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Custom mHealth App Development</h3>
                        <p>
                          Our medical app developers are masters in developing
                          mHealth apps for remote health monitoring that meet
                          FDA, HIPAA, and HL7 regulations. Our pioneering
                          healthcare app solutions speed up diagnosis, improve
                          patient data access, and promote effortless
                          collaboration between patients, doctors, pharmacists,
                          and hospital administration.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/redefine-img/electronic_health.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Electronic Health Record Software</h3>
                        <p>
                          As the best healthcare app development company, we
                          specialize in developing powerful Electronic Health
                          Record (EHR) software platforms to empower medical
                          professionals. We provide quick access to patient
                          histories and medical data through intuitive patient
                          portals, keeping doctors in touch with their patients.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="4">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/redefine-img/telemedicine.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Telemedicine App Development</h3>
                        <p>
                          Our medical app developers have hands-on experience in
                          developing software that allows patients to directly
                          communicate with doctors via messaging and video
                          calling. Our apps prioritize user-friendly interfaces
                          and strong security measures to ensure that patients
                          get convenient, excellent treatment while healthcare
                          professionals can easily convey their expertise
                          regardless of geographical challenges.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="5">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/redefine-img/pharmacy.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Pharmacy Management App Development</h3>
                        <p>
                          Being a healthcare app development services provider,
                          our healthcare app developers have created several
                          safe single-application systems within pharmacy apps.
                          These solutions help you optimize medicine refilling,
                          analyze key KPIs such as inventory turnover, and
                          improve overall efficiency. We can assist you in
                          modernizing your existing pharmacy management software
                          with cutting-edge technology that enables real-time
                          communication, fully automated payment processing, and
                          workflow automation.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="6">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/redefine-img/compliance.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>HIPAA-Compliant Software</h3>
                        <p>
                          Our medical app developers have the necessary skills
                          to produce HIPAA-compliant applications. To ensure
                          that patient data is secure at all encounters, we use
                          cutting-edge encryption technologies and tight access
                          controls while developing apps. We recognize the vital
                          role that patient trust plays in the healthcare
                          industry, and our firm commitment to data privacy
                          highlights our promise to safeguard each person's
                          private information across our network.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="7">
                        <div className="redefine_tabs_img">
                          <StaticImage
                            src="../../images/services-usa/healthcare-new/redefine-img/medical.webp"
                            alt="TekRevol"
                            layout="constrained"
                            placeholder="blurred"
                            formats={["webp"]}
                            width={53}
                            height={43}
                          />
                        </div>
                        <h3>Wearable Technology Integration</h3>
                        <p>
                          Being a top healthcare mobile app development company,
                          we are experts at integrating wearables with your
                          software and utilizing IoMT to create a user
                          experience and functionality that's unparalleled. We
                          provide consumers with real-time health data and
                          actionable insights through wearables integration into
                          your app, enabling proactive healthcare management and
                          educated decision-making.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Redefinepatientservices;
